"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>Voice_RealTimeVoiceModalInfo
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const RealTimeVoiceModalInfo = ({ onContinue })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
        padding: 3,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                color: "text.heading",
                fontSize: '26px',
                lineHeight: '32px',
                fontWeight: "bold",
                children: "Penny Voice. Now with real-time, natural conversations."
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                mt: 4,
                fontSize: 1,
                children: "Searching for hotels or updating your travel plans is now easier than ever with Penny Voice."
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text, {
                mt: 4,
                fontSize: 1,
                children: [
                    ' ',
                    "Enjoy real-time responses, the ability to interrupt anytime, and smooth, personalized interactions that adapt to your needs.",
                    ' '
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text, {
                mt: 4,
                fontSize: 1,
                children: [
                    ' ',
                    "Ready to experience the future of travel assistance? Try Penny Voice today and see how effortless and fun travel planning can be!"
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Button, {
                width: 1,
                mt: 4,
                onClick: onContinue,
                children: "Continue"
            })
        ]
    });
const Voice_RealTimeVoiceModalInfo = RealTimeVoiceModalInfo;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
